import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import { getDefaultLocale, translator } from "../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { localeSetLanguage } from "../actions";
import { goToBeginning } from "../utils/scenario-manager";

const useStyles = makeStyles(theme => ({
  root: {
    transform: "translateZ(0px)",
    zIndex: 10,
    marginRight: "6px"
  },
  exampleWrapper: {
    position: "relative"
  },
  backdropRoot: {
    zIndex: 9
  },
  speedDial: {
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2)
    }
  }
}));

const actions = [
  {
    icon: <img width="40" src="images/fr.svg" alt="" />,
    name: translator()._("W_LANG_FR"),
    value: "fr"
  },
  {
    icon: <img width="40" src="images/en.svg" alt="" />,
    name: translator()._("W_LANG_EN"),
    value: "en"
  },
  {
    icon: <img width="40" src="images/it.svg" alt="" />,
    name: translator()._("W_LANG_IT"),
    value: "it"
  },
  {
    icon: <img width="40" src="images/de.svg" alt="" />,
    name: translator()._("W_LANG_DE"),
    value: "de"
  },
  {
    icon: <img width="40" src="images/es.svg" alt="" />,
    name: translator()._("W_LANG_ES"),
    value: "es"
  }
];

export default function LocaleSwitcher() {
  const classes = useStyles();
  const direction = "down";
  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();

  const language =
    useSelector(state => state.locale.language) || getDefaultLocale();
  const setLanguageFunc = language => dispatch(localeSetLanguage(language));
  const goToBeginningFunc = () => dispatch(goToBeginning());
  const onChangeLocale = lang => {
    setLanguageFunc(lang);
    goToBeginningFunc();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getActions = (actions, lang) => {
    var actionsResult = [];
    actions.forEach(action => {
      if (action.value !== lang) {
        actionsResult.push(
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => onChangeLocale(action.value)}
          />
        );
      }
    });
    return actionsResult;
  };

  return (
    <>
      <Backdrop open={open} className={classes.backdropRoot} />
      <div className={classes.root}>
        <div className="wrap-speedDial">
          <SpeedDial
            ariaLabel="SpeedDial menu"
            className={classes.speedDial}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={direction}
            icon={<img width="40" src={`images/${language}.svg`} alt="" />}
          >
            {getActions(actions, language)}
          </SpeedDial>
        </div>
      </div>
    </>
  );
}
